import React from 'react';
import { Button, Modal } from 'antd';
import type { PanelStatus } from 'types/credentialing';
import { AllState } from 'constants/common';
import { EFeatureType } from 'types/provider';
import HomeStore from 'store/Home';

const getStateName = (code?: string) => AllState.find((i) => i.dictKey === code)?.content || code || '';

interface Props {
    // 待撤回的 panel 行；null 时不显示
    target: PanelStatus | null;
    loading?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

// 撤回 pending panel 的确认弹窗（原型 cred-ad-modal 同款文案：后果前置——进度丢失、押金退回、可随时重提）
export default function WithdrawPayerModal({ target, loading, onCancel, onConfirm }: Props) {
    const stateName = getStateName(target?.state);
    // 按这一行 panel 自己的押金快照判断（后端撤回也按它退款）：开免押金前付过 $50 的仍会退。
    // 旧后端没下发该字段时退回按账号开关判断
    const [getHomeStore] = HomeStore.useStore();
    const feeWaived = !!getHomeStore('data')?.features?.includes(EFeatureType.CREDENTIALING_FEE_WAIVED);
    const refundable = (target?.depositAmountCents ?? (feeWaived ? 0 : 1)) > 0;
    return (
        <Modal
            open={!!target}
            onCancel={onCancel}
            title={`Withdraw ${target?.name || ''}${stateName ? ` (${stateName})` : ''}?`}
            width={543}
            centered
            destroyOnClose
            footer={[
                <Button key="cancel" onClick={onCancel} disabled={loading}>
                    Cancel
                </Button>,
                <Button key="withdraw" danger type="primary" loading={loading} onClick={onConfirm}>
                    Withdraw
                </Button>,
            ]}
        >
            <p style={{ fontSize: 14, color: '#374151', lineHeight: 1.6, margin: 0 }}>
                This stops all work on your {target?.name} application{stateName ? ` in ${stateName}` : ''} and cannot
                be undone. Any credentialing progress made so far is lost
                {refundable ? ', though your deposit for this panel will be refunded.' : '.'} You can resubmit{' '}
                {target?.name}
                {stateName ? ` in ${stateName}` : ''} anytime from Select payers.
            </p>
        </Modal>
    );
}
